import * as React from 'react';
import {
  ParentHeaderChip,
  ParentPageHeader
} from '../../ParentView/components/ParentPageHeader';

export type StudentHeaderChip = ParentHeaderChip;

interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  chips?: StudentHeaderChip[];
  actions?: React.ReactNode;
  tabs?: Array<{ label: string; active?: boolean; count?: number; onClick: () => void }>;
}

export const StudentPageHeader = (props: Props) => <ParentPageHeader {...props} />;

StudentPageHeader.displayName = 'StudentPageHeader';
